import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { getVerbalHotelReviews } from '../../../../utils/format';
import { RatingBar } from '../RatingBar';
import { CategoryRu } from '../../../../models/hotel-reviews';
import AggregateRating from 'sletat-ui-components2/dist/components/AggregateRating';

export interface CategoryRatingProps {
    category: CategoryRu;
    rating: number | null;
    reviewCount: number;
}

interface StyledCategoryRatingProps
    extends JSSClassesProps<ComponentJSSClasses>,
        CategoryRatingProps {}

export const CategoryRating = React.memo(function(props: StyledCategoryRatingProps) {
    const { classes, category, rating, reviewCount } = props;

    return (
        <div className={`${classes.container} ${rating ? '' : classes.withoutRating}`}>
            <AggregateRating rating={rating || 0} />
            <div className={classes.rightSide}>
                <RatingBar rating={rating ?? 0} />
                <div className={classes.textContent}>
                    <p className={`${classes.category} ${!reviewCount && classes.categoryEmpty}`}>
                        {category}
                    </p>
                    <p className={classes.reviewCount}>
                        {reviewCount ? `${reviewCount} ${getVerbalHotelReviews(reviewCount)}` : 'нет оценки'}
                    </p>
                </div>
            </div>
        </div>
    );
});
